export const EVENT_HEIGHT = 21;
export const DEFAULT_ROW_HEIGHT = 100;
